/* eslint-disable */
import React, { useState, useContext, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { get } from 'session';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DragAndDrop from 'modules/common/components/DragAndDrop';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import useFormValidator from 'useFormValidator';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import Alert from 'react-s-alert';
import { customStyle, ucwords } from 'helper';
import CmsContext from 'context/CmsContext';
import LeafletMap from 'modules/common/components/LeafletMap';
import BusinessActivityList from '../components/BusinessActivityList';
import Address from 'modules/common/address/Address';
import * as c from '../constant';
import * as actions from '../actions';
import Citizenship from '../components/Citizenship';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';

function UpdateModal({
  updateApplication,
  id,
  history,
  getItem,
  getRegionsList,
  getProvinceList,
  getMunicipalityList,
  getBarangayList,
  regionsList,
  provinceList,
  municipalityList,
  barangayList,
  updating,
  updateList,
  createUploader,

  getVetRegistrationList,
  vetRegistrationList,
  businessActivityList,
  getBusinessNecessaryField,
  businessNecessaryField,
  getCalculationDetailsList,
  calculationDetailsList,
  getCheckBarangayClearance,
  checkBarangayClearance,
}) {
  const [formData, setFormData] = useState({
    area: '',
    floor_area: '',
    base_line: '',
    no_of_male_employees: '',
    no_of_female_employees: '',
    no_of_employees: '',
    no_of_employees_residing_manila: '',
    no_of_van: '',
    no_of_truck: '',
    no_of_motorcycle: '',
    region_code: '130000000',
    province_code: '133900000',
    municipality_code: '',
    barangay_code: '',
    street: '',
    zip_code: '',
    location_owned: 0,
    with_tax_incentives: 0,
    tdn_no: '',
    pin_no: '',
    pin_selected: 0, //
    tdn_selected: 0, //
    tax_incentives_attachment_url: '',
    kind_of_ownership: '',
    owners_gender: '',
    tin_no: '',
    dti_no: '',
    sec_no: '',
    cda_no: '',
    monthly_rental: 0,
    business_name: '',
    trade_name: '',
    lessor_name: '',
    cellphone_no: '',
    telephone_no: '',
    email_address: '',
    nationality: '',
    incharge_last_name: '',
    incharge_first_name: '',
    incharge_middle_name: '',
    incharge_suffix_name: '',
    main_office_region_code: '130000000',
    main_office_province_code: '133900000',
    main_office_municipality_code: '',
    main_office_barangay_code: '',
    main_office_street: '',
    main_office_zip_code: '',
    activity_type: '',
    activity_type_others: '',
    pinned_geolocation: '',
    is_validated: '',

    // veterinary registration
    veterinary_fee_id: '',
    calculation_details: {},
    dti_registration_expiry_date: '',
  });

  const cmsContext = useContext(CmsContext);
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const formIsPinSelected = _.get(formData, 'pin_selected');
  const formIsTdnSelected = _.get(formData, 'tdn_selected');
  const bplsPin19DigitRegex = _.get(
    CMS_MASKINGS,
    'BPLS_E2E_PIN_19_DIGIT_REGEX'
  );
  const bplsPin19Digit = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_19_DIGIT');
  const bplsPinRegex = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN_REGEX');
  const bplsPin = _.get(CMS_MASKINGS, 'BPLS_E2E_PIN');
  const defaultPin19Digit = _.get(
    CMS_MASKINGS,
    'DEFAULT_BPLS_E2E_PIN_19_DIGIT'
  );
  const defaultPin = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_PIN');
  const bplsTdnRegex = _.get(CMS_MASKINGS, 'BPLS_E2E_TDN_REGEX');
  const bplsTdn = _.get(CMS_MASKINGS, 'BPLS_E2E_TDN');
  const defaultTdn = _.get(CMS_MASKINGS, 'DEFAULT_BPLS_E2E_TDN');

  const formPinnedLocation = _.get(formData, 'pinned_geolocation', '');
  const defaultLat = +_.get(CMS_COMPONENTS, 'BPLS_PINNED_LOCATION_LATITUDE', 0);
  const defaultLng = +_.get(CMS_COMPONENTS, 'BPLS_PINNED_LOCATION_LONGITUDE', 0);

  const selectedCoords = useMemo(() => {
    const defaultCoords = {
      lat: defaultLat,
      lng: defaultLng,
    };

    if (!formPinnedLocation) return defaultCoords;

    const [lat, lng] = formPinnedLocation.split(',');
    return {
      lat: +lat,
      lng: +lng,
    };
  }, [formPinnedLocation, defaultLat, defaultLng]);

  const [formDataCalculation, setFormDataCalculation] = useState({});
  const [formDataBusinessNecessaryField, setFormDataBusinessNecessaryField] =
    useState({});
  const [businessNecessaryData, setBusinessNecessaryData] = useState({});
  const [formDataQuantityMatrix, setFormDataQuantityMatrix] = useState({});

  let commonValidation = {
    kind_of_ownership: 'required',
    owners_gender:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
    business_name: 'required|max_200_char',
    trade_name: 'max_200_char',
    dti_no:
      'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|min_5_alphanumeric|max_20_alphanumeric',
    sec_no:
      'required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|min_5_alphanumeric|max_20_alphanumeric',
    cda_no:
      'required_if:kind_of_ownership=COOPERATIVE|min_5_alphanumeric|max_20_alphanumeric',
    cellphone_no: 'required|cellphone_number',
    telephone_no: 'tel_number',
    email_address: 'required|email',
    municipality_code: 'required',
    barangay_code: 'required',
    zip_code: 'required|number',
    incharge_first_name: 'required',
    incharge_last_name: 'required',
    nationality:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=CORPORATION',
    area: 'required|number',
    floor_area: 'required|number',
    base_line: 'required|number',
    no_of_male_employees: 'required|number',
    no_of_female_employees: 'required|number',
    no_of_employees_residing_manila: 'required|number',
    no_of_van: 'required|number',
    no_of_truck: 'required|number',
    no_of_motorcycle: 'required|number',
    main_office_municipality_code: 'required',
    main_office_barangay_code: 'required',
    main_office_zip_code: 'required|number',
    lessor_name: 'required_if:location_owned=0',
    monthly_rental: 'required|number',
    with_tax_incentives: 'required',
    tax_incentives_attachment_url: 'required_if:with_tax_incentives=1',
    activity_type: 'required',
    region_code: 'required',
    province_code: 'required',
    main_office_region_code: 'required',
    main_office_province_code: 'required',
    tdn_no: 'required_if:tdn_selected=1|min_5_char|max_20_char',
    pin_no: 'required_if:pin_selected=1|min_5_char|max_20_char',
    dti_registration_expiry_date: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  useEffect(() => {
    const defaultPinMask = defaultPin
      ? 'required_if:pin_selected=1|min_5_char|max_20_char'
      : `required_if:pin_selected=1|mask:${bplsPinRegex}~${bplsPin}`;
    const defaultPin19DigitMask = defaultPin19Digit
      ? 'required_if:pin_selected=1|min_5_char|max_20_char'
      : `required_if:pin_selected=1|mask:${bplsPin19DigitRegex}~${bplsPin19Digit}`;

    if (!formIsPinSelected && defaultPin && defaultPin19Digit) return;

    validateForm.onSetObjectRules({
      ...commonValidation,
      pin_no: _.get(formData, 'pin_format')
        ? defaultPin19DigitMask
        : defaultPinMask,
    });
  }, [formIsPinSelected, _.get(formData, 'pin_format')]);

  useEffect(() => {
    if (formIsTdnSelected && !defaultTdn) {
      validateForm.onSetObjectRules({
        ...commonValidation,
        tdn_no: `required_if:tdn_selected=1|mask:${bplsTdnRegex}~${bplsTdn}`,
      });
    }
  }, [formIsTdnSelected]);

  const calculationValidationRules = Object.keys(formDataCalculation).reduce(
    (acc, key) => ({
      ...acc,
      [key]: 'required',
    }),
    {}
  );

  const validateFormCalculation = useFormValidator(
    formDataCalculation,
    calculationValidationRules
  );

  useEffect(() => {
    setTimeout(() => {
      validateFormCalculation.onSetObjectRules(calculationValidationRules);
      // validateFormCalculation.validate();
    }, 2000);

  }, [_.get(formData, 'with_barangay_clearance'), formData.main_office_barangay_code]);

  const handleChangeValue = (key) => (value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const setModal = useContext(ModalContext);
  const addressList = _.get(updateList, 'included.bplsBusiness.attributes');

  useEffect(() => {
    getRegionsList();
  }, []);

  useEffect(() => {
    getVetRegistrationList();
  }, []);

  useEffect(() => {
    getProvinceList({
      region_code: _.get(addressList, 'region_code'),
      main_office_region_code: _.get(addressList, 'main_office_region_code'),
      per_page: 10000,
    });
  }, []);

  useEffect(() => {
    getMunicipalityList({
      province_code: _.get(addressList, 'province_code'),
      main_office_province_code: _.get(
        addressList,
        'main_office_province_code'
      ),
      display_all: 1,
      per_page: 10000,
    });
  }, []);

  useEffect(() => {
    getBarangayList({
      municipality_code: _.get(addressList, 'municipality_code'),
      main_office_municipality_code: _.get(
        addressList,
        'main_office_municipality_code'
      ),
      display_all: 1,
      per_page: 50000,
    });
  }, []);

  // const calculationDetails = _.get(
  //   updateList,
  //   'included.bplsApplication.attributes.calculation_details'
  // );

  const validateBusinessNecessary = Object.keys(formDataBusinessNecessaryField)
    .map((item) => {
      return { [item]: 'required' };
    })
    .values();

  const setValidateBusinessNecessary = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const value of validateBusinessNecessary) {
      setBusinessNecessaryData((prevData) => ({
        ...prevData,
        ...value,
      }));
    }
  };

  useEffect(() => {
    setValidateBusinessNecessary();
  }, [formDataBusinessNecessaryField]);

  const validateFormBusinessNecessary = useFormValidator(
    formDataBusinessNecessaryField,
    businessNecessaryData
  );

  useEffect(() => {
    validateFormBusinessNecessary.onSetObjectRules(businessNecessaryData);
  }, [formDataBusinessNecessaryField]);

  useEffect(() => {
    validateFormBusinessNecessary.validate();
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.isEmpty(businessActivityList)) {
      Alert.error(
        'Business Activity must be validated or have atleast one business activity'
      );
      return false;
    }

    if (
      !validateForm.response.is_passed &&
      !validateFormCalculation.response.is_passed &&
      !validateFormBusinessNecessary.response.is_passed
    ) {
      return false;
    }

    const businessNecessary = {
      ...formDataBusinessNecessaryField,
      quantity_matrix: formDataQuantityMatrix,
    };

    const args = {
      ...formData,
      // calculation details
      calculation_details: formDataCalculation,

      // convert string value to int
      no_of_employees: +_.get(formData, 'no_of_employees'),
      no_of_employees_residing_manila: +_.get(
        formData,
        'no_of_employees_residing_manila'
      ),
      no_of_male_employees: +_.get(formData, 'no_of_male_employees'),
      no_of_female_employees: +_.get(formData, 'no_of_female_employees'),
      no_of_vehicles: +_.get(formData, 'no_of_vehicles'),
      no_of_van: +_.get(formData, 'no_of_van'),
      no_of_truck: +_.get(formData, 'no_of_truck'),
      no_of_motorcycle: +_.get(formData, 'no_of_motorcycle'),

      dti_no:
        _.get(formData, 'dti_no') === null
          ? ''
          : _.get(formData, 'dti_no').toUpperCase(),
      sec_no:
        _.get(formData, 'sec_no') === null
          ? ''
          : _.get(formData, 'sec_no').toUpperCase(),
      cda_no:
        _.get(formData, 'cda_no') === null
          ? ''
          : _.get(formData, 'cda_no').toUpperCase(),
      activity_type:
        _.get(formData, 'activity_type') === 'others'
          ? _.get(formData, 'activity_type_others')
          : _.get(formData, 'activity_type'),
      tin_no:
        _.get(formData, 'tin_no') === null ? '' : _.get(formData, 'tin_no'),
      tdn_no:
        _.get(formData, 'tdn_no') === null
          ? ''
          : _.get(formData, 'tdn_no').toUpperCase(),
      pin_no:
        _.get(formData, 'pin_no') === null
          ? ''
          : _.get(formData, 'pin_no').toUpperCase(),
      details: businessNecessary || {},
      dti_registration_expiry_date: _.get(formData, 'dti_registration_expiry_date') !== null 
        && _.get(formData, 'dti_registration_expiry_date') !== '' 
        && _.get(business, 'dti_registration_expiry_date') !== 'Invalid date'
          ? moment(_.get(formData, 'dti_registration_expiry_date', '')).format('YYYY-MM-DD')
          : '',
    };

    return updateApplication(id, args, () => {
      const pathName = history.location.pathname;
      setModal({ isOpen: false });
      getItem(id);

      if (pathName.indexOf('/bpls/applications/renewal') > -1) {
        return history.push(`/bpls/applications/renewal/${id}`);
      }
      return history.push(`/bpls/applications/new/${id}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  // TODO: find a better or cleaner solution, refactor later
  const checkNumberOfEmployees = (employeesData) => {
    if (
      _.get(updateList, 'attributes.no_of_employees') === 0 ||
      _.get(updateList, 'attributes.no_of_employees') === '0'
    )
      return '0';
    if (
      _.get(updateList, 'attributes.no_of_employees') !== 0 ||
      _.get(updateList, 'attributes.no_of_employees') !== '0'
    ) {
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(updateList, 'attributes.no_of_male_employees') !== 0 ||
          _.get(updateList, 'attributes.no_of_female_employees') !== 0)
      )
        return '0';
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(updateList, 'attributes.no_of_male_employees') === 0 ||
          _.get(updateList, 'attributes.no_of_female_employees') === 0)
      )
        return '';
    }
    return employeesData;
  };

  useEffect(() => {
    if (!_.isEmpty(updateList)) {
      const business = _.get(updateList, 'included.bplsBusiness.attributes');

      setFormData({
        ...formData,
        area: _.get(business, 'area') || '',
        floor_area: _.get(business, 'floor_area') || '',
        base_line: _.get(business, 'base_line') || '0',

        no_of_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : _.get(business, 'no_of_employees') || '',
        // eslint-disable-next-line eqeqeq
        no_of_employees_residing_manila:
          checkNumberOfEmployees(
            _.get(business, 'no_of_employees_residing_manila')
          ) || '',
        no_of_male_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : `${_.get(business, 'no_of_male_employees')}` || '',

        no_of_female_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : `${_.get(business, 'no_of_female_employees')}` || '',
        no_of_vehicles: _.get(business, 'no_of_vehicles') || '0',
        no_of_van: _.get(business, 'no_of_van') || '0',
        no_of_truck: _.get(business, 'no_of_truck') || '0',
        no_of_motorcycle: _.get(business, 'no_of_motorcycle') || '0',

        region_code: _.get(business, 'region_code') || '',
        province_code: _.get(business, 'province_code') || '',
        municipality_code: _.get(business, 'municipality_code') || '',
        barangay_code: _.get(business, 'barangay_code') || '',
        street: _.get(business, 'street') || '',
        zip_code: _.get(business, 'zip_code') || '',
        location_owned: _.get(business, 'location_owned') || 0,
        with_tax_incentives: !_.isEmpty(
          _.get(business, 'tax_incentives_attachment_url')
        )
          ? 1
          : 0,
        tdn_no: _.get(business, 'tdn_no', '') || '',
        pin_no: _.get(business, 'pin_no', '') || '',
        pin_selected: _.get(business, 'pin_no') ? 1 : 0,
        tax_incentives_attachment_url: _.get(
          business,
          'tax_incentives_attachment_url'
        ),
        kind_of_ownership: _.get(business, 'kind_of_ownership') || '',
        owners_gender: _.get(business, 'owners_gender') || '',
        tin_no: _.get(business, 'tin_no'),
        dti_no: _.get(business, 'dti_no'),
        sec_no: _.get(business, 'sec_no'),
        cda_no: _.get(business, 'cda_no'),
        monthly_rental: _.get(business, 'monthly_rental') || 0,
        business_name: _.get(business, 'business_name') || '',
        trade_name: _.get(business, 'trade_name') || '',
        lessor_name: _.get(business, 'lessor_name') || '',
        cellphone_no: _.get(business, 'cellphone_no') || '',
        telephone_no: _.get(business, 'telephone_no') || '',
        email_address: _.get(business, 'email_address') || '',
        nationality: _.get(business, 'nationality') || '',
        incharge_last_name: _.get(business, 'incharge_last_name') || '',
        incharge_first_name: _.get(business, 'incharge_first_name') || '',
        incharge_middle_name: _.get(business, 'incharge_middle_name') || '',
        incharge_suffix_name: _.get(business, 'incharge_suffix_name') || '',
        main_office_region_code:
          _.get(business, 'main_office_region_code') || '',
        main_office_province_code:
          _.get(business, 'main_office_province_code') || '',
        main_office_municipality_code:
          _.get(business, 'main_office_municipality_code') || '',
        main_office_barangay_code:
          _.get(business, 'main_office_barangay_code') || '',
        main_office_street: _.get(business, 'main_office_street') || '',
        main_office_zip_code: _.get(business, 'main_office_zip_code') || '',
        activity_type: _.get(business, 'activity_type') || '',
        pinned_geolocation: _.get(business, 'pinned_geolocation') || '',
        is_validated: _.get(business, 'is_validated'),
        calculation_details: _.get(business, 'calculation_details') || {},
        veterinary_fee_id: _.get(business, 'veterinary_fee_id') || '',
        with_barangay_clearance:
          _.get(
            updateList,
            'included.bplsApplication.attributes.with_barangay_clearance'
          ) || 0,
        pin_format: _.get(business, 'pin_format') ? 1 : 0,
        dti_registration_expiry_date: _.get(business, 'dti_registration_expiry_date') !== ''
          && _.get(business, 'dti_registration_expiry_date') !== null 
          && _.get(business, 'dti_registration_expiry_date') !== 'Invalid date'
            ? moment(_.get(business, 'dti_registration_expiry_date', '')).format('MM-DD-YYYY')
            : '',
      });
    }
  }, []);

  // useEffect(() => {
  //   if (!_.isEmpty(calculationDetails)) {
  //     setFormDataCalculation({
  //       ...formDataCalculation,
  //       ...calculationDetails,
  //     });
  //   }
  // }, []);

  useEffect(() => {
    const barangayCode = _.get(formData, 'main_office_barangay_code') 
      ? _.get(formData, 'main_office_barangay_code') 
      : _.get(updateList, 'included.bplsBusiness.attributes.main_office_barangay_code'); 
    const withBarangayClearance = _.get(formData, 'with_barangay_clearance', 0)
//       ? _.get(formData, 'with_barangay_clearance')
//       : _.get(updateList, 'included.bplsApplication.attributes.with_barangay_clearance');
//     formData.with_barangay_clearance
    const args = {
      main_office_barangay_code: barangayCode,
      with_barangay_clearance: withBarangayClearance,
    };

    getCalculationDetailsList(id, args, ({ res }) => {
      setFormDataCalculation(res || calculationDetailsList);
    });
  }, [
    _.get(formData, 'main_office_barangay_code'),
    _.get(formData, 'with_barangay_clearance'),
  ]);

  const onChangeRadioLocationOwned = (e) => {
    if (e.target.value === '1') {
      setFormData({
        ...formData,
        [e.target.name]: +e.target.value,
        lessor_name: '',
        monthly_rental: '0.00',
        tdn_selected: 1,
        pin_format: 0,
      });
    }

    if (e.target.value === '0') {
      setFormData({
        ...formData,
        [e.target.name]: +e.target.value,
        pin_no: '',
        tdn_no: '',
        pin_selected: 0,
        tdn_selected: 0,
      });
    }

    return null;
  };

  const onChangeRadio = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: +e.target.value,
    });
  };

  const onChangeCheckbox = (e) => {
    if (e.target.checked) {
      setFormData({
        ...formData,
        tdn_no: '',
        pin_selected: 1,
        tdn_selected: 0,
      });
    }

    if (!e.target.checked) {
      setFormData({
        ...formData,
        pin_no: '',
        pin_selected: 0,
        tdn_selected: 1,
        pin_format: 0,
      });
    }
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onChangeCalculationDetails = (e) => {
    const { name, value } = e;

    setFormDataCalculation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const findGenderValue =
    c.OWNERS_GENDER.find(
      (item) => _.get(formData, 'owners_gender') === _.get(item, 'value')
    ) || '';

  const handleOnChangeRadio = (e) => {
    if (e.target.value !== 'others') {
      setFormData({
        ...formData,
        activity_type: e.target.value,
        activity_type_others: '',
      });
    }

    setFormData({
      ...formData,
      activity_type: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
    // }, [Object.values(formData)]);
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    validateFormCalculation.validate();
  }, [Object.values(formDataCalculation).join(',')]);

  const onChangePhoto = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data.cdnUrl,
    });
  };

  // vet reg filter dropdown
  const listOption =
    vetRegistrationList.map((item) => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';

  const addedData = {
    label: 'Select',
    value: '',
  };

  const sortOption = (listOption || []).concat([addedData]);
  const vetRegistrationListOption = _.orderBy(sortOption, ['value'], ['asc']);

  const handlePinFormat = (e) => {
    if (e.target.checked) {
      setFormData({
        ...formData,
        pin_format: 1,
      });
    }

    if (!e.target.checked) {
      setFormData({
        ...formData,
        pin_no: _.get(formData, 'pin_no')?.replace(
          `/${_.get(CMS_MASKINGS, 'BPLS_E2E_DTI_NO_REGEX')}/`,
          '$1-$2-$3-$4-$5'
        ), // format pin_no into (000-00-000-000-000) // todo: add this to masking/cms for dynamic handling of pinformat
        pin_format: 0,
      });
    }
  };

  const business = _.get(
    updateList,
    'included.bplsBusiness.attributes.details'
  );
  const { quantity_matrix, ...details } = business;

  useEffect(() => {
    if (!_.isEmpty(business)) {
      setFormDataBusinessNecessaryField({
        ...formDataBusinessNecessaryField,
        ...details,
      });
    }
  }, []);

  const onChangeBusinessNecessaryField = (e) => {
    setFormDataBusinessNecessaryField({
      ...formDataBusinessNecessaryField,
      [e.target.name]: e ? e.target.value : '',
    });
  };

  const multiplierQuantityMatrix = Object.values(quantity_matrix ?? {})
    .flatMap(item => _.isArray(item) ? item : [])
    .reduce((acc, { multiplier, value }) => {
      if (multiplier && !isNaN(value)) {
        acc[multiplier] = +value;
      }
      return acc;
  }, {});
  
  useEffect(() => {
    if (!_.isEmpty(multiplierQuantityMatrix)) {
      setFormDataQuantityMatrix({
        ...formDataQuantityMatrix,
        ...multiplierQuantityMatrix,
      });
    }
  }, []);

  const onChangeQuantityMatrix = (key, value) => {
    setFormDataQuantityMatrix({
      ...formDataQuantityMatrix,
      [key]: value,
    });
  };

  const onSelectDetails = (key) => (e) => {
    setFormDataBusinessNecessaryField((prevDetail) => ({
      ...prevDetail,
      [key]: e.value,
    }));
  };

  useEffect(() => {
    getBusinessNecessaryField({
      application_status_id: get('applicationStatusId') || 0,
    });
  }, []);

  const selectOptions = (list) => {
    const newList = [];

    if (_.isEmpty(list)) return false;

    list.map((data) => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  useEffect(() => {
    if (_.get(formData, 'location_owned') === 1) {
      setFormData({
        ...formData,
        lessor_name: '',
        monthly_rental: 0,
      });
    }
  }, [_.get(formData, 'location_owned')]);

  const checkBarangayClearancePayload = {
    barangay_code: _.get(formData, 'main_office_barangay_code') || 0,
    transaction_type:
      _.get(updateList, 'included.bplsBusiness.attributes.type') || 'NEW',
  };

  useEffect(() => {
    if (!_.isEmpty(_.get(formData, 'main_office_barangay_code'))) {
      getCheckBarangayClearance(checkBarangayClearancePayload);
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(_.get(formData, 'main_office_barangay_code'))) {
      getCheckBarangayClearance(checkBarangayClearancePayload);
    }
  }, [_.get(formData, 'main_office_barangay_code')]);

  useEffect(() => {
    if (_.get(checkBarangayClearance, 'with_barangay_clearance') === 0) {
      setFormData((prev) => ({
        ...prev,
        with_barangay_clearance: 0,
      }));
    }
  }, [_.get(checkBarangayClearance, 'with_barangay_clearance')]);

  const onCheck = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked ? 1 : 0,
    }));
  };

  const onChangeBusinessAddress = (e) => {
    const values = _.get(e, 'target.value', {});
    const formattedValues = {
      main_office_region_code: _.get(values, 'region_code', ''),
      main_office_province_code: _.get(values, 'province_code', ''),
      main_office_municipality_code: _.get(values, 'municipality_code', ''),
      main_office_barangay_code: _.get(values, 'barangay_code', ''),
      main_office_zip_code: _.get(values, 'zip_code', ''),
      main_office_street: _.get(values, 'street', ''),
    };
    setFormData((prev) => {
      const currentBarangayCode = _.get(prev, 'main_office_barangay_code', '');
      const nextBarangayCode = _.get(formattedValues, 'main_office_barangay_code', '');
      const isBarangayChanged = currentBarangayCode !== nextBarangayCode;
      const resetBarangayClearance =
        !_.isEmpty(currentBarangayCode) &&
        _.get(prev, 'with_barangay_clearance') === 1 &&
        isBarangayChanged;

      return {
        ...prev,
        ...formattedValues,
        with_barangay_clearance: resetBarangayClearance
          ? 0
          : _.get(prev, 'with_barangay_clearance', 0),
      };
    });
  };

  const onChangeTaxPayerAddress = (e) => {
    const values = _.get(e, 'target.value', {});
    setFormData({
      ...formData,
      ...values,
    });
  };

  const onChangeDate = (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const renderInputMaskConfigFromCms = (isPinSelected, pinFormat) => {
    if (isPinSelected && pinFormat) {
      return !defaultPin19Digit ? bplsPin19Digit : '';
    }

    if (isPinSelected && !pinFormat) {
      return !defaultPin ? bplsPin : '';
    }

    if (!isPinSelected && !pinFormat) {
      return !defaultTdn ? bplsTdn : '';
    }

    return '';
  };

  const filteredBusinessNecessaryField = businessNecessaryField.filter(
    (item) => !item.quantity_matrix
  );

  const filteredQuantityMatrix = businessNecessaryField.filter(
      item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
    );

  // const quantityMatrix = filteredQuantityMatrix?.quantity_matrix || [];

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Information and Registration
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Type: {validateForm.renderMessage('kind_of_ownership')}
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select Module"
                onChange={handleOnChangeSelect('kind_of_ownership')}
                options={c.KIND_OF_OWNERSHIP}
                value={
                  c.KIND_OF_OWNERSHIP.find(
                    (item) =>
                      _.get(formData, 'kind_of_ownership') ===
                      _.get(item, 'value')
                  ) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Owners Sex: {validateForm.renderMessage('owners_gender')}
                {/* {['PARTNERSHIP', 'CORPORATION', 'COOPERATIVE'].indexOf(
                  _.get(formData, 'kind_of_ownership')
                ) > -1
                  ? ' (Not Applicable)'
                  : ''} */}
              </label>
              <Select
                // isDisabled={disableOwnersGender(
                //   _.get(formData, 'kind_of_ownership')
                // )}
                isClearable
                name="owners_gender"
                placeholder="Select Sex"
                onChange={handleOnChangeSelect('owners_gender')}
                options={c.OWNERS_GENDER}
                value={findGenderValue}
              />
            </div>
            {formData.kind_of_ownership === 'SOLE PROPRIETORSHIP' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  DTI Registration Number:{' '}
                  {validateForm.renderMessage('dti_no')}
                </label>
                <input
                  className="form-control"
                  // placeholder="AA000000000"
                  type="text"
                  name="dti_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'dti_no') || ''}
                />
              </div>
            )}
            {formData.kind_of_ownership === 'SOLE PROPRIETORSHIP' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  DTI Registration Expiry Date:{' '}
                  {validateForm.renderMessage('dti_registration_expiry_date')}
                </label>
                <DateInputPicker
                  className="full-input"
                  onChange={onChangeDate('dti_registration_expiry_date')}
                  value={_.get(formData, 'dti_registration_expiry_date', '') || ''}
                />
              </div>
            )}
            {['ONE PERSON CORPORATION', 'PARTNERSHIP', 'CORPORATION'].indexOf(
              _.get(formData, 'kind_of_ownership')
            ) > -1 && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  SEC Registration Number:{' '}
                  {validateForm.renderMessage('sec_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="sec_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'sec_no') || ''}
                />
              </div>
            )}
            {formData.kind_of_ownership === 'COOPERATIVE' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  CDA Registration Number:{' '}
                  {validateForm.renderMessage('cda_no')}
                </label>
                <input
                  className="form-control"
                  // placeholder="AA000000000"
                  type="text"
                  name="cda_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'cda_no') || ''}
                />
              </div>
            )}

            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Tax Identification Number:
                {/* {validateForm.renderMessage('tin_no')} */}
              </label>
              <InputMask
                className="form-control"
                mask="999-999-999-999"
                alwaysShowMask={false}
                type="text"
                name="tin_no"
                onChange={onChange}
                value={_.get(formData, 'tin_no') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Name: {validateForm.renderMessage('business_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="business_name"
                onChange={onChange}
                value={_.get(formData, 'business_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Trade Name / Franchise (If Applicable) :{' '}
                {validateForm.renderMessage('trade_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="trade_name"
                onChange={onChange}
                value={_.get(formData, 'trade_name') || ''}
              />
            </div>

            {/* owner's/president's name */}
            <div className="container">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                President&apos;s Name / Owner&apos;s Name
              </div>
              <div className="row">
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    First Name:{' '}
                    {validateForm.renderMessage('incharge_first_name')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="incharge_first_name"
                    onChange={onChange}
                    value={_.get(formData, 'incharge_first_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Middle Name
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="incharge_middle_name"
                    onChange={onChange}
                    value={_.get(formData, 'incharge_middle_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Last Name:{' '}
                    {validateForm.renderMessage('incharge_last_name')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="incharge_last_name"
                    onChange={onChange}
                    value={_.get(formData, 'incharge_last_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Extension Name
                  </label>
                  <Select
                    name="incharge_suffix_name"
                    placeholder="Select Suffix Name"
                    onChange={handleOnChangeSelect('incharge_suffix_name')}
                    options={c.EXTENSION_NAMES}
                    value={
                      c.EXTENSION_NAMES.find(
                        (item) =>
                          _.get(formData, 'incharge_suffix_name') ===
                          _.get(item, 'value')
                      ) || ''
                    }
                  />
                </div>
                {(formData.kind_of_ownership === 'CORPORATION' ||
                  formData.kind_of_ownership === 'ONE PERSON CORPORATION' ||
                  formData.kind_of_ownership === 'PARTNERSHIP' ||
                  formData.kind_of_ownership === 'COOPERATIVE') && (
                  <div className="col-6 form-group">
                    <label className="form-label mb-0">
                      Country of Citizenship:{' '}
                      {validateForm.renderMessage('nationality')}
                    </label>
                    <Citizenship
                      name="nationality"
                      onChange={onChange}
                      value={_.get(formData, 'nationality') || ''}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* contact info */}
            <div className="container">
              <div className="row text-primary font-weight-bold mb-2">
                Contact Information
              </div>
              <div className="row">
                <div className="col-6 form-group">
                  <label className="form-label mb-0">
                    E-mail Address:{' '}
                    {validateForm.renderMessage('email_address')}
                  </label>
                  <input
                    className="form-control"
                    type="email"
                    name="email_address"
                    onChange={onChange}
                    value={_.get(formData, 'email_address') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Mobile Number: {validateForm.renderMessage('cellphone_no')}
                  </label>
                  <InputMask
                    className="form-control"
                    mask="999999999999"
                    alwaysShowMask
                    type="text"
                    name="cellphone_no"
                    onChange={onChange}
                    value={_.get(formData, 'cellphone_no') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Telephone Number:{' '}
                    {validateForm.renderMessage('telephone_no')}
                  </label>
                  <InputMask
                    className="form-control"
                    mask="99-9999-9999"
                    alwaysShowMask={false}
                    type="text"
                    name="telephone_no"
                    onChange={onChange}
                    value={_.get(formData, 'telephone_no') || ''}
                  />
                </div>
              </div>
            </div>

            {/* business address */}
            <div className="container">
              <div className="row text-primary font-weight-bold mb-2">
                Business Address
              </div>
              <Address
                required
                value={{
                  region_code: _.get(formData, 'main_office_region_code') || '',
                  province_code:
                    _.get(formData, 'main_office_province_code') || '',
                  municipality_code:
                    _.get(formData, 'main_office_municipality_code') || '',
                  barangay_code:
                    _.get(formData, 'main_office_barangay_code') || '',
                }}
                onChange={onChangeBusinessAddress}
                region_name="main_office_region_code"
                province_name="main_office_province_code"
                municipality_name="main_office_municipality_code"
                barangay_name="main_office_barangay_code"
                name="main_office"
                withStreet={false}
                validatorMessage={validateForm.renderMessage}
                removeLabel
                regionDisabled
                provinceDisabled
                municipalityDisabled
              />
              <div className="row py-2">
                <div className="col-6 form-group mt-2">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Unit/Room Number/Floor, Building Name, House Number, Street
                    Name:
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="main_office_street"
                    onChange={onChange}
                    value={_.get(formData, 'main_office_street') || ''}
                  />
                </div>
                <div className="col-6 form-group mt-2">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Zip Code:{' '}
                    {validateForm.renderMessage('main_office_zip_code')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    mask="9999"
                    name="main_office_zip_code"
                    onChange={onChange}
                    value={_.get(formData, 'main_office_zip_code') || ''}
                  />
                </div>
                {_.get(checkBarangayClearance, 'with_barangay_clearance') ? (
                  <div className="col-6 form-group">
                    <input
                      className="mx-0 mb-2"
                      name="with_barangay_clearance"
                      type="checkbox"
                      checked={Boolean(
                        _.get(formData, 'with_barangay_clearance')
                      )}
                      onChange={onCheck}
                    />
                    <label className="form-label m-0 py-2 ml-2 font-medium">
                      Barangay Clearance
                    </label>
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div
                style={{ height: '300px', width: '100%' }}
                className="mt-3 d-flex flex-column"
              >
                <LeafletMap
                  pins={[selectedCoords]}
                  center={[selectedCoords.lat, selectedCoords.lng]}
                  zoom={17}
                  showSearch
                  onMapClick={(newPin) => {
                    setFormData((prevForm) => ({
                      ...prevForm,
                      pinned_geolocation: `${newPin.latlng.lat},${newPin.latlng.lng}`,
                    }));
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Operation
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="floor_area" className="form-label mb-0">
                Total Floor Area (sq.m):{' '}
                {validateForm.renderMessage('floor_area')}
              </label>
              <NumberFormat
                name="floor_area"
                id="floor_area"
                placeholder="0.00"
                className="mt-1 form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const floorArea = Number(value || 0);
                  const areaValue = Number(_.get(formData, 'area') || 0);
                  setFormData({
                    ...formData,
                    floor_area: value,
                    area:
                      floorArea > 0 && areaValue > floorArea
                        ? value
                        : _.get(formData, 'area', ''),
                  });
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                thousandSeparator
                allowLeadingZeros
                value={_.get(formData, 'floor_area')}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="area" className="form-label mb-0">
                Business Area (sq.m):{' '}
                {validateForm.renderMessage('area')}
              </label>
              <NumberFormat
                name="area"
                id="area"
                placeholder="0.00"
                className="mt-1 form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const floorArea = Number(_.get(formData, 'floor_area') || 0);
                  const areaValue = Number(value || 0);
                  const nextArea =
                    floorArea > 0 && areaValue > floorArea ? _.get(formData, 'floor_area') : value;
                  setFormData({
                    ...formData,
                    area: nextArea,
                  });
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                thousandSeparator
                allowLeadingZeros
                value={_.get(formData, 'area')}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Employees residing within Area:{' '}
                {validateForm.renderMessage('no_of_employees_residing_manila')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_employees_residing_manila"
                onChange={onChange}
                value={_.get(formData, 'no_of_employees_residing_manila') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Total Number of Male Employees:{' '}
                {validateForm.renderMessage('no_of_male_employees')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_male_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_male_employees') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Total Number of Female Employees:{' '}
                {validateForm.renderMessage('no_of_female_employees')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_female_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_female_employees') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Van Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_van')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_van"
                onChange={onChange}
                value={_.get(formData, 'no_of_van') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Truck Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_truck')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_truck"
                onChange={onChange}
                value={_.get(formData, 'no_of_truck') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Motorcycle Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_motorcycle')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_motorcycle"
                onChange={onChange}
                value={_.get(formData, 'no_of_motorcycle') || ''}
              />
            </div>
            {filteredBusinessNecessaryField.map((item, i) => {
              const multiplier = _.get(item, 'multiplier');

              return (
                <React.Fragment key={multiplier}>
                  {_.get(item, 'options') ? (
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="col-6 form-group">
                      <label className="form-label mb-0">
                        {ucwords(multiplier ?? '').replace(/_/g, ' ')}{' '}
                        {validateFormBusinessNecessary.renderMessage(
                          `${multiplier}`
                        )}
                      </label>
                      <Select
                        name={multiplier}
                        options={selectOptions(_.get(item, 'options'))}
                        value={
                          selectOptions(_.get(item, 'options')).find(
                            (option) => {
                              return (
                                _.get(
                                  formDataBusinessNecessaryField,
                                  multiplier
                                ) === _.get(option, 'value')
                              );
                            }
                          ) || ''
                        }
                        onChange={onSelectDetails(multiplier)}
                        components={{ IndicatorSeparator: () => null }}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                  {!_.get(item, 'options') ? (
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="col-6 form-group">
                      <label htmlFor="last_name" className="form-label mb-0">
                        {ucwords(multiplier ?? '').replace(/_/g, ' ')}:{' '}
                        {validateFormBusinessNecessary.renderMessage(
                          `${multiplier}`
                        )}
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name={multiplier}
                        onChange={onChangeBusinessNecessaryField}
                        value={
                          _.get(
                            formDataBusinessNecessaryField,
                            `${multiplier}`
                          ) || ''
                        }
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </React.Fragment>
              );
            })}
            {!_.isEmpty(filteredQuantityMatrix) ? (
              filteredQuantityMatrix?.map((item) => {
                const multiplier = _.get(item, 'multiplier', '');
                return (
                  <React.Fragment>
                    <div className='form-group col-12 mb-0'>
                      <label className='form-label mb-0 text-capitalize'>
                        {multiplier}
                      </label>
                    </div>
                    <div className='w-100 border rounded-lg mx-3 mb-3'>
                      <table className="table table-borderless table-sm table-striped table-hover">
                        <thead>
                          <tr className='form-group'>
                            <td className='col-4 form-label text-center border-right'>Unit</td>
                            <td className='col-4 form-label text-center border-right'>Capacity</td>
                            <td className='col-4 form-label text-center'>Number of Units</td>
                          </tr>
                        </thead>
                        <tbody>
                          {item.quantity_matrix.map((quantityMatrixItem) => {
                            const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              <tr key={quantityMatrixMultiplier} className="top-border form-group">
                                <td className="col-4 text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'unit')} 
                                </td>
                                <td className="col-4 text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'capacity')}
                                </td>
                                <td className="col-4 text-left form-label">
                                  <NumberFormat
                                    name={quantityMatrixMultiplier}
                                    id={quantityMatrixMultiplier}
                                    className="form-control"
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      onChangeQuantityMatrix(quantityMatrixMultiplier, floatValue);
                                    }}
                                    displayType="input"
                                    decimalScale={2}
                                    thousandSeparator
                                    allowLeadingZeros
                                    isNumericString
                                    value={_.get(formDataQuantityMatrix, `${quantityMatrixMultiplier}`, '')}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                )
              })
            ) : (
              ''
            )}
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Taxpayer&apos;s Address
        </div>
        <div className="container-fluid">
          <Address
            required
            value={{
              region_code: _.get(formData, 'region_code') || '',
              province_code: _.get(formData, 'province_code') || '',
              municipality_code: _.get(formData, 'municipality_code') || '',
              barangay_code: _.get(formData, 'barangay_code') || '',
            }}
            onChange={onChangeTaxPayerAddress}
            region_name="region_code"
            province_name="province_code"
            municipality_name="municipality_code"
            barangay_name="barangay_code"
            name="tax_payer_address"
            withStreet={false}
            validatorMessage={validateForm.renderMessage}
            removeLabel
            regionDisabled={false}
            provinceDisabled={false}
            municipalityDisabled={false}
          />
          <div className="row py-2">
            <div className="col-6 form-group mt-2">
              <label htmlFor="last_name" className="form-label mb-0">
                Unit/Room Number/Floor, Building Name, House Number, Street
                Name:
              </label>
              <input
                className="form-control"
                type="text"
                name="street"
                onChange={onChange}
                value={_.get(formData, 'street') || ''}
              />
            </div>
            <div className="col-6 form-group mt-2">
              <label htmlFor="last_name" className="form-label mb-0">
                Zip Code: {validateForm.renderMessage('zip_code')}
              </label>
              <input
                className="form-control"
                mask="9999"
                type="text"
                name="zip_code"
                onChange={onChange}
                value={_.get(formData, 'zip_code') || ''}
              />
            </div>
            <div className="col-6 form-group mb-0 pb-0">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <label htmlFor="last_name" className="form-label mr-2 mb-1">
                  Owned?
                </label>
                <div className="d-flex flex-row justify-content-center px-0 mx-0">
                  <div className="d-flex align-items-center">
                    <input
                      type="radio"
                      name="location_owned"
                      style={{ width: '20px', height: '20px' }}
                      onChange={onChangeRadioLocationOwned}
                      checked={_.get(formData, 'location_owned') === 1}
                      value="1"
                    />
                    <label className="full-label mb-0 mx-1">Yes</label>
                  </div>
                  <div className="d-flex align-items-center mr-2">
                    <input
                      type="radio"
                      name="location_owned"
                      style={{ width: '20px', height: '20px' }}
                      onChange={onChangeRadioLocationOwned}
                      checked={_.get(formData, 'location_owned') === 0}
                      value="0"
                    />
                    <label className="full-label mb-0 mx-1">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 form-group" />{' '}
            {/* placeholder only to avoid collapsing of ONWED? input */}
            {formData.location_owned === 1 ? (
              <div className="col-6 form-group">
                <div className="row d-flex align-items-center justify-content-between">
                  <div className="col-6">
                    <label className="form-label ">
                      {formIsPinSelected !== 1
                        ? 'Tax Declaration No.'
                        : 'Property Identification No.'}{' '}
                      {formIsPinSelected !== 1
                        ? validateForm.renderMessage('tdn_no')
                        : validateForm.renderMessage('pin_no')}
                    </label>
                  </div>
                  <div className="col-6 text-right">
                    {formIsPinSelected ? (
                      <label className="form-label ">
                        19-digit Format:
                        <input
                          name="pin_format"
                          type="checkbox"
                          checked={_.get(formData, 'pin_format') ? 1 : 0}
                          onChange={handlePinFormat}
                          className="mx-2 mb-2"
                        />
                      </label>
                    ) : null}
                    <label className="form-label">PIN:</label>
                    {/* checkbox */}
                    <input
                      className="mx-2 mb-2"
                      type="checkbox"
                      name="pin_selected"
                      onChange={onChangeCheckbox}
                      checked={formIsPinSelected}
                    />
                  </div>
                </div>
                {/* input */}
                <InputMask
                  className="form-control"
                  placeholder=""
                  mask={renderInputMaskConfigFromCms(
                    formIsPinSelected,
                    _.get(formData, 'pin_format')
                  )}
                  alwaysShowMask={false}
                  maskChar=""
                  type="text"
                  name={formIsPinSelected !== 1 ? 'tdn_no' : 'pin_no'}
                  id={formIsPinSelected !== 1 ? 'tdn_no' : 'pin_no'}
                  onChange={onChange}
                  value={
                    formIsPinSelected !== 1
                      ? _.get(formData, 'tdn_no', '').toUpperCase()
                      : _.get(formData, 'pin_no', '').toUpperCase() || ''
                  }
                />
              </div>
            ) : (
              <>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Lessor Name (if applicable):{' '}
                    {validateForm.renderMessage('lessor_name')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="lessor_name"
                    onChange={onChange}
                    value={_.get(formData, 'lessor_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="monthly_rental" className="form-label mb-0">
                    Monthly Rental:{' '}
                    {validateForm.renderMessage('monthly_rental')}
                  </label>
                  <NumberFormat
                    name="monthly_rental"
                    id="monthly_rental"
                    placeholder="0.00"
                    className="mt-1 form-control"
                    onValueChange={(values) => {
                      const { value } = values;
                      setFormData({
                        ...formData,
                        monthly_rental: value,
                      });
                    }}
                    displayType="input"
                    decimalScale={2}
                    isNumericString
                    allowNegative
                    thousandSeparator
                    allowLeadingZeros
                    prefix="₱ "
                    value={_.get(formData, 'monthly_rental')}
                    isAllowed={(values) => {
                      const { value } = values;
                      if (!value) return true;
                      const val = new Decimal(value);
                      const max = new Decimal(MAX_LIMIT);
                      return value === undefined || val.lte(max);
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <div className="row px-2">
            <div className="col-6 form-group py-2">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <label htmlFor="last_name" className="form-label mr-2 mb-1">
                  Tax Incentives from any Government Entity:{' '}
                  {validateForm.renderMessage('with_tax_incentives')}
                </label>
                <div className="d-flex flex-row justify-content-center px-0 mx-0">
                  <div className="d-flex align-items-center mr-2">
                    <input
                      type="radio"
                      name="with_tax_incentives"
                      style={{ width: '20px', height: '20px' }}
                      onChange={onChangeRadio}
                      checked={_.get(formData, 'with_tax_incentives') === 1}
                      value="1"
                    />
                    <label className="full-label mb-0 mx-1">Yes</label>
                  </div>

                  <div className="d-flex align-items-center">
                    <input
                      type="radio"
                      name="with_tax_incentives"
                      style={{ width: '20px', height: '20px' }}
                      onChange={onChangeRadio}
                      checked={_.get(formData, 'with_tax_incentives') === 0}
                      value="0"
                    />
                    <label className="full-label mb-0 mx-1">No</label>
                  </div>
                </div>
              </div>
            </div>
            {formData.with_tax_incentives === 1 ? (
              <div className="col-12 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Tax Incentive{' '}
                  {validateForm.renderMessage('tax_incentives_attachment_url')}
                </label>
                <div className="row d-flex">
                  <div className="col-6">
                    <div className="row d-flex justify-content-center">
                      <div className="col-12 form-group">
                        {!(
                          _.get(formData, 'tax_incentives_attachment_url') || ''
                        ).includes('pdf') ? (
                          <img
                            className="w-100 rounded"
                            src={
                              _.get(
                                formData,
                                'tax_incentives_attachment_url'
                              ) || ''
                            }
                            alt=""
                          />
                        ) : (
                          <iframe
                            title="Birth certificate requirements"
                            style={{ width: '100%', height: '400px' }}
                            className="img img-fluid"
                            alt={`tax_incentives_attachment_url${_.get(
                              formData,
                              'id'
                            )}`}
                            src={_.get(
                              formData,
                              'tax_incentives_attachment_url'
                            )}
                          />
                        )}

                        <FilePondSingleUpload
                          value={
                            _.get(formData, 'tax_incentives_attachment_url') ||
                            ''
                          }
                          onChange={handleChangeValue(
                            'tax_incentives_attachment_url'
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        {/* business calculation details */}
        <div className="container">
          <div className="row text-primary font-weight-bold mb-2">
            Calculation Details
          </div>

          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Veterinary Registration:{' '}
                {/* {validateForm.renderMessage('veterinary_fee_id')} */}
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select"
                onChange={handleOnChangeSelect('veterinary_fee_id')}
                options={vetRegistrationListOption}
                value={
                  vetRegistrationListOption.find((item) => {
                    return (
                      `${_.get(formData, 'veterinary_fee_id')}` ===
                      _.get(item, 'value')
                    );
                  }) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Base Line: {validateForm.renderMessage('base_line')}
              </label>
              <input
                className="form-control"
                type="text"
                name="base_line"
                onChange={onChange}
                value={_.get(formData, 'base_line') || ''}
              />
            </div>
            {Object.entries(formDataCalculation).map((item) => {
              return (
                <div key={item[0]} className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    {ucwords(item[0].replace(/_/g, ' '))}:
                    {validateFormCalculation.renderMessage(`${item[0]}`)}
                  </label>
                  <NumberFormat
                    name={item[0]}
                    id={item[0]}
                    placeholder="0.00"
                    className="form-control"
                    onValueChange={(values) => {
                      const { value } = values;
                      const prop = {
                        name: item[0],
                        value,
                      };
                      onChangeCalculationDetails(prop);
                    }}
                    displayType="input"
                    decimalScale={2}
                    isNumericString
                    allowNegative
                    thousandSeparator
                    allowLeadingZeros
                    prefix="₱ "
                    value={_.get(formDataCalculation, item[0])}
                    isAllowed={(values) => {
                      const { value } = values;
                      if (!value) return true;
                      const val = new Decimal(value);
                      const max = new Decimal(MAX_LIMIT);
                      return value === undefined || val.lte(max);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold my-2">
          Business Activities{' '}
          <span className="px-1">
            {validateForm.renderMessage('activity_type')}
          </span>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 form-group d-flex flex-row align-items-center justify-content-between px-3 py-2 my-0">
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'MAIN OFFICE'}
                value="MAIN OFFICE"
              />
              <label className="form-label pr-3 m-0">Main Office</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'BRANCH OFFICE'}
                value="BRANCH OFFICE"
              />
              <label className="form-label pr-3 m-0">Branch Office</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={
                  _.get(formData, 'activity_type') === 'ADMIN OFFICE ONLY'
                }
                value="ADMIN OFFICE ONLY"
              />
              <label className="form-label pr-3 m-0">Admin Office only</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'WAREHOUSE'}
                value="WAREHOUSE"
              />
              <label className="form-label pr-3 m-0">Warehouse</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'OTHERS'}
                value="OTHERS"
              />
              <label className="form-label pr-3 m-0">Others</label>
              <input
                className="col-4 custom-input"
                disabled={_.get(formData, 'activity_type') !== 'OTHERS'}
                type="text"
                name="activity_type_others"
                onChange={onChange}
                placeholder="Pls specify"
                value={_.get(formData, 'activity_type_others') || ''}
              />
            </div>
          </div>
        </div>
        <BusinessActivityList
          businessId={id}
          pathName={history.location.pathname}
        />
        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              !validateFormCalculation.response.is_passed ||
              !validateFormBusinessNecessary.response.is_passed
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateApplication: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,

  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,

  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  updating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,

  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
  businessActivityList: PropTypes.instanceOf(Array).isRequired,
  getBusinessNecessaryField: PropTypes.instanceOf(Function).isRequired,
  businessNecessaryField: PropTypes.instanceOf(Object).isRequired,
  getCalculationDetailsList: PropTypes.instanceOf(Function).isRequired,
  calculationDetailsList: PropTypes.instanceOf(Object).isRequired,
  getCheckBarangayClearance: PropTypes.instanceOf(Function).isRequired,
  checkBarangayClearance: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],

  vetRegistrationList: _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
  businessActivityList:
    _.get(api, `${c.GET_BUSINESS_ACTIVITY_LIST}.list`) || [],
  businessNecessaryField:
    _.get(api, `${c.GET_BUSINESS_NECESSARY_FIELD}.list`) || [],
  calculationDetailsList:
    _.get(api, `${c.GET_CALCULATION_DETAILS_LIST}.res`) || {},
  checkBarangayClearance:
    _.get(api, `${c.GET_CHECK_BARANGAY_CLEARANCE}.res`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
